/**
 * DIEUKYDIEU.TV - AUDIO TRACKS PLAYLIST (PART 2: TRACKS 4-7)
 */

export const tracksPart2 = [
    {
        id: "track-4",
        title: "Điều chờ mong trong mộng",
        title_i18n: {
            vi: "Điều chờ mong trong mộng",
            en: "Dreaming Hope",
            "zh-TW": "夢中尋覓",
            "zh-CN": "梦中寻觅"
        },
        artist: "Giai Điệu Tĩnh Lặng • dieukydieu.tv",
        artist_i18n: {
            vi: "Giai Điệu Tĩnh Lặng • dieukydieu.tv",
            en: "Serene Melodies • dieukydieu.tv",
            "zh-TW": "清幽旋律 • dieukydieu.tv",
            "zh-CN": "清幽旋律 • dieukydieu.tv"
        },
        img: "https://picsum.photos/400/400?random=204",
        src: "https://www.zhengjian.org/sites/default/files/files/2026/07/chongfantianting-jx.mp3",
        duration: "4:30",
        lyrics: `Trong giấc mộng lành ta thấy ánh quang minh,
Soi rọi tâm hồn qua những ngày giông bão.
Những điều kỳ diệu hiển hiện quanh ta,
Khi lòng biết bao dung và thiện lương mở lối.

Hãy giữ vững niềm tin vào những điều tốt đẹp,
Bởi chân lý luôn trường tồn cùng năm tháng.
Gửi trọn yêu thương vào từng nốt nhạc êm đềm,
Để tâm hồn lắng đọng trong an nhiên tự tại.`,
        syncedLyrics: [
            { time: 12, text: "Trong giấc mộng lành ta thấy ánh quang minh," },
            { time: 28, text: "Soi rọi tâm hồn qua những ngày giông bão." },
            { time: 45, text: "Những điều kỳ diệu hiển hiện quanh ta," },
            { time: 62, text: "Khi lòng biết bao dung và thiện lương mở lối." },
            { time: 88, text: "Hãy giữ vững niềm tin vào những điều tốt đẹp," },
            { time: 106, text: "Bởi chân lý luôn trường tồn cùng năm tháng." },
            { time: 124, text: "Gửi trọn yêu thương vào từng nốt nhạc êm đềm," },
            { time: 144, text: "Để tâm hồn lắng đọng trong an nhiên tự tại." }
        ]
    },
    {
        id: "track-5",
        title: "Trọn mộng ngàn năm",
        title_i18n: {
            vi: "Đơn ca nữ: Trọn mộng ngàn năm",
            en: "Female Solo: Millennium Dream Fulfilled",
            "zh-TW": "女聲獨唱：千年夢圓",
            "zh-CN": "女声独唱：千年梦圆"
        },
        artist: "Tịnh Tâm • Zhengjian Art",
        credits: "Biểu diễn: Tịnh Tâm • Lời: Như Nguyện • Nhạc & Phối khí: Minh Kha",
        artist_i18n: {
            vi: "Tịnh Tâm • Zhengjian Art",
            en: "Jingxin • Zhengjian Art",
            "zh-TW": "靜心 • 正見藝術",
            "zh-CN": "静心 • 正见艺术"
        },
        img: "https://picsum.photos/400/400?random=205",
        src: "https://www.zhengjian.org/sites/default/files/files/2025/12/qnymjsy-jx.mp3",
        duration: "4:05",
        lyrics: `Vượt bao dặm trường trong sương gió,
Ngàn năm mộng ước nay vẹn toàn.
Theo chân Phật Chủ về thiên giới,
Cởi bỏ bụi trần chốn thế gian.

Chân lý soi đường xua bóng tối,
Từ bi cứu độ khắp muôn loài.
Ghi khắc trong tim lời thệ nguyện,
Trọn vẹn ước mơ tự thuở nào.

(Đơn ca nữ: Trọn mộng ngàn năm
Lời: Như Nguyện - Nhạc & Phối khí: Minh Kha - Biểu diễn: Tịnh Tâm)`,
        syncedLyrics: [
            { time: 12, text: "Vượt bao dặm trường trong sương gió," },
            { time: 26, text: "Ngàn năm mộng ước nay vẹn toàn." },
            { time: 42, text: "Theo chân Phật Chủ về thiên giới," },
            { time: 58, text: "Cởi bỏ bụi trần chốn thế gian." },
            { time: 84, text: "Chân lý soi đường xua bóng tối," },
            { time: 100, text: "Từ bi cứu độ khắp muôn loài." },
            { time: 118, text: "Ghi khắc trong tim lời thệ nguyện," },
            { time: 136, text: "Trọn vẹn ước mơ tự thuở nào." }
        ]
    },
    {
        id: "track-6",
        title: "Chúng tôi là con của Phật Chủ",
        title_i18n: {
            vi: "Hợp ca: Chúng tôi là con của Phật Chủ",
            en: "Chorus: We Are the Children of the Lord Buddha",
            "zh-TW": "合唱：我們是主佛的孩子",
            "zh-CN": "合唱：我们是主佛的孩子"
        },
        artist: "Hợp ca Đại Pháp • Zhengjian Art",
        credits: "Hợp ca: Các đệ tử Đại Pháp • Lời: Thanh Không • Nhạc: Tri Ân • Biên khúc: Phương Thảo",
        artist_i18n: {
            vi: "Hợp ca Đại Pháp • Zhengjian Art",
            en: "Dafa Disciples Chorus • Zhengjian Art",
            "zh-TW": "大法弟子合唱 • 正見藝術",
            "zh-CN": "大法弟子合唱 • 正见艺术"
        },
        img: "https://picsum.photos/400/400?random=206",
        src: "https://www.zhengjian.org/sites/default/files/files/2025/04/zhufodehaizihc.mp3",
        duration: "4:28",
        lyrics: `Chúng tôi là con của Phật Chủ,
Được sinh ra nơi thiên trì mỹ lệ,
Thuần chân thánh khiết thiện lương và thành thực.

Chúng tôi là con của Phật Chủ,
Ký hợp ước cùng Chủ trợ Pháp cứu thế,
Luân hồi ngàn năm không quên hồng thệ.

Chân - Thiện - Nhẫn chiếu rọi khắp muôn phương,
Đưa vạn linh trở về cùng cội nguồn quang minh.

(Hợp ca: Chúng tôi là con của Phật Chủ
Lời: Thanh Không - Nhạc: Tri Ân - Biên khúc: Phương Thảo - Diễn xướng: Các đệ tử Đại Pháp)`,
        syncedLyrics: [
            { time: 15, text: "Chúng tôi là con của Phật Chủ," },
            { time: 30, text: "Được sinh ra nơi thiên trì mỹ lệ," },
            { time: 48, text: "Thuần chân thánh khiết thiện lương và thành thực." },
            { time: 75, text: "Chúng tôi là con của Phật Chủ," },
            { time: 92, text: "Ký hợp ước cùng Chủ trợ Pháp cứu thế," },
            { time: 112, text: "Luân hồi ngàn năm không quên hồng thệ." },
            { time: 138, text: "Chân - Thiện - Nhẫn chiếu rọi khắp muôn phương," },
            { time: 160, text: "Đưa vạn linh trở về cùng cội nguồn quang minh." }
        ]
    },
    {
        id: "track-7",
        title: "Tôi đến từ chốn rất xa xôi",
        title_i18n: {
            vi: "Sáo Dizi: Tôi đến từ chốn rất xa xôi",
            en: "Dizi Flute: I Come From a Distant Place",
            "zh-TW": "笛子獨奏：我從遙遠走來",
            "zh-CN": "笛子独奏：我从遥远走来"
        },
        artist: "Sáo Dizi: Nguyễn Hà • Zhengjian Art",
        credits: "Diễn tấu: Nguyễn Hà • Lời: Thanh Không • Nhạc: Tri Ân • Phối khí: Minh Kha",
        artist_i18n: {
            vi: "Sáo Dizi: Nguyễn Hà • Zhengjian Art",
            en: "Dizi Flute: Nguyen Ha • Zhengjian Art",
            "zh-TW": "笛子：阮河 • 正見藝術",
            "zh-CN": "笛子：阮河 • 正见艺术"
        },
        img: "https://picsum.photos/400/400?random=207",
        src: "https://www.zhengjian.org/sites/default/files/files/2025/08/wocongyaoyuanzoulai.mp3",
        duration: "3:52",
        lyrics: `Tôi từ nơi cùng tận xa xôi đến,
Để chờ đợi Phật Pháp vĩ đại quang minh.
Trong tâm khắc ghi phó thác của chúng sinh,
Chí tín kiên tu Đại Pháp không đổi dời.

Tiếng sáo vi vu ngân vang khúc thiên đình,
Đánh thức tâm can qua muôn vạn trùng kiếp.
Bình minh rạng ngời xua tan màn đêm tối,
Dìu dắt nhau về chốn cố hương thanh bình.

(Sáo Dizi: Tôi đến từ chốn rất xa xôi [ChanhKien.org]
Lời: Thanh Không - Nhạc: Tri Ân - Phối khí: Minh Kha - Diễn tấu: Nguyễn Hà)`,
        syncedLyrics: [
            { time: 14, text: "Tôi từ nơi cùng tận xa xôi đến," },
            { time: 28, text: "Để chờ đợi Phật Pháp vĩ đại quang minh." },
            { time: 46, text: "Trong tâm khắc ghi phó thác của chúng sinh," },
            { time: 64, text: "Chí tín kiên tu Đại Pháp không đổi dời." },
            { time: 90, text: "Tiếng sáo vi vu ngân vang khúc thiên đình," },
            { time: 108, text: "Đánh thức tâm can qua muôn vạn trùng kiếp." },
            { time: 128, text: "Bình minh rạng ngời xua tan màn đêm tối," },
            { time: 148, text: "Dìu dắt nhau về chốn cố hương thanh bình." }
        ]
    }
];
